export default __webpack_public_path__ + "static/media/slide_2.01ab7d4e.jpg";